import { formatMoney } from '../../../utils/lookahead-common';
import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';

const realCostCol = (gantt, t) => ({
  name: 'real_cost',
  label: 'Costo Ganado',
  align: 'center',
  template: (activity) => {
    let isOdd = false;
    if (gantt.oddColsConfig) {
      isOdd = gantt.oddColsConfig.real_cost;
    }
    const hasChild = gantt.hasChild(activity.id);
    const lang = t('lang');
    const formattedCost =
      lang === 'en'
        ? formatMoney(activity.real_cost, '$', 2, '.', ',')
        : formatMoney(activity.real_cost);

    return `
      <div class="${isOdd ? 'odd-col' : 'non-odd-col'}" 
           style="font-weight: ${hasChild ? 600 : 100}; color: #121212;" 
           ${activity.type === 'project' ? `onclick="window.to_use_react_gantt.showGanttAlert('${t('schedule_notification.calculated_column_value')}', ${activity.id}, 'earned_cost', 'Calculated_Summary_Activity_Edit_Attempt')"` : ''}>
        ${formattedCost}
      </div>
    `;
  },
  data_type: 'number',
  hide: !isColumnVisibleByDefault('real_cost'),
  groupable: false,
  orderable: true,
  orderable_switch: ['1 → 9', '9 → 1'],
  filterable: true,
  resize: true
});

export default realCostCol; 